<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.partners', 1) }}
                    </h3>
                </div>
            </div>

            <div class="">
                <div class="card">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                      
                        </h3>
                    </div>
                    <b-container>
                        <div class="list-group list-group-flush">
                            <b-row>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.region') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mPartner.region).toUpperCase() }}
                            </span>
                                    </div>
                                </b-col>


                                <div class="col-sm-12">
                                    <div class="list-group-item">
                                        {{ $tc('message.cities',1) }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mPartner.ville).charAt(0).toUpperCase()+""+getValue(mPartner.ville).slice(1) }}
                            </span>
                                    </div>
                                </div>

                          

                                <div class="col-sm-12">
                                    <div class="list-group-item">
                                        {{ $tc('message.partner', 1) }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mPartner.nom).charAt(0).toUpperCase()+""+getValue(mPartner.nom).slice(1) }}
                            </span>
                                    </div>
                                </div>
                            

                                <div class="col-sm-12">
                                    <div class="list-group-item">
                                        {{ $t('message.adresse') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mPartner.localisation).charAt(0).toUpperCase()+""+getValue(mPartner.localisation).slice(1) }}
                            </span>
                                    </div>
                                </div>

                                <div class="col-sm-12">
                                    <div class="list-group-item">
                                        {{ $t('message.email') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mPartner.email) }}
                            </span>
                                    </div>
                                </div>

                                <div class="col-sm-12">
                                    <div class="list-group-item">
                                        {{ $t('message.phoneNumber') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mPartner.telephone) }}
                            </span>
                                    </div>
                                </div>

                                <div class="col-sm-12">
                                    <div class="list-group-item">
                                        {{ $tc('message.personContact', 1) }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mPartner.contact).charAt(0).toUpperCase()+""+getValue(mPartner.contact).slice(1) }}
                            </span>
                                    </div>
                                </div>

                            </b-row>

                            <b-row>

                                
                            </b-row>
                        </div>
                    </b-container>
                    <div class="">
                        <b-row class="justify-content-sm-center" v-if="can || hasAssistante">
                            <div class="card-footer addpatient">
                                <b-button variant="primary" class="mt-2" @click="updatePartner">
                                    {{ $t('message.edit') }}
                                </b-button>

                                <b-button v-b-modal.delete-modal variant="danger" class="mt-2">
                                    {{ $t('message.delete') }}
                                </b-button>
                            </div>
                        </b-row>
                    </div>

                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.partners', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mPartner.nom }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deletePartner">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import AppConfig from '../../constants/AppConfig';


    export default {
        name: "Partners",

        computed: {
            ...mapGetters(["Partner",'hasAdminRole',
                'hasGestionnaireRole','hasMedecinControleRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            mPartner: function() {
                return this.Partner;
            },

            fullName:function () {
                let contact  = this.mPartner.contact != null ? this.mPartner.contact : "";
                contact =   getValue(contact);
                return contact.charAt(0).toUpperCase();
            },
        },

        data() {
            return {
                partner_id: this.$route.params.partner,

                paginationOptions:{
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled:{enabled: true},
            }
        },

        methods: {

            getPartner() {
                let args = {
                    partenaire: this.partner_id
                };

                this.$store.dispatch("getPartner", { args });
            },

            formattedDate(date) {
                return moment(date).format('DD-MM-YYYY HH:mm');
            },

            updatePartner() {
                this.$router.push({ name: 'edit-partner', params: { partner: this.partner_id } });
            },

            deletePartner() {
                let self = this;
                let args = {
                    partenaire: this.partner_id
                };

                let successMessage = this.$i18n.t('message.partnerDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deletePartner', { args, index: self.partner_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            },
            getValue(item){
                if (typeof item != "undefined"){
                    return item;
                }else{
                    return "";
                }
            },
        },
        mounted() {
            this.getPartner();
        }
    }
</script>

<style scoped>

</style>